import { render, staticRenderFns } from "./HabitHolder.vue?vue&type=template&id=22ac3b82&scoped=true&"
import script from "./HabitHolder.vue?vue&type=script&setup=true&lang=ts&"
export * from "./HabitHolder.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./HabitHolder.vue?vue&type=style&index=0&id=22ac3b82&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22ac3b82",
  null
  
)

export default component.exports